module.exports = __webpack_public_path__ + "static/media/SnappyDefaultLogo.c8959f7d.svg";